
import { defineComponent } from "vue";
import api, { UserList, User, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: UserList;
  requestFilter: User;
  requestPaging: RequestPaging;
  requestSorting: RequestSort,
  pageBounds: PageBounding[];
  filterOptions: Record<string, unknown>;
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverUser",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const user_list = { } as UserList;
    const user_struct = { } as User;
    const paging_struct = { Limit: 5, Skip: 0, Options: [ 5, 10, 20 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {
      'Status': [
        { 'label': 'Enabled', 'value': 'active' },
        { 'label': 'Disabled', 'value': 'inactive' }
      ]
    };

    return {
      msg: "Receiver Users",
      backendResponse: user_list,
      requestFilter: user_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    clearFiltersAndRefresh() {
      const filter_struct = { } as User;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse = { } as UserList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getUserList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
